import Layout from '@layout/Index'

export const order = [
  {
    path: '/order',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "order-table" */ './pages/OrderTable.vue'),
        name: '工单列表',
        meta: {
          title: '工单列表',
        },
      },
      {
        path: 'assigned-review-table',
        component: () => import(/* webpackChunkName: "order-review-table" */ './pages/AssignedReviewTable.vue'),
        name: '待分配复核列表',
        meta: {
          title: '待分配复核列表',
        },
      },
      {
        path: 'assign-review',
        component: () => import(/* webpackChunkName: "order-assign-review" */ './pages/AssignReviewPage.vue'),
        name: '分配复核',
        meta: {
          title: '分配复核',
        },
      },
      {
        path: 'archived/table',
        component: () => import(/* webpackChunkName: "order-table" */ './pages/OrderArchivedTable.vue'),
        name: '工单列表(归档)',
        meta: {
          title: '工单列表(归档)',
        },
      },
      {
        path: 'appeal/table',
        component: () => import(/* webpackChunkName: "order-appeal-table" */ './pages/OrderAppealTable.vue'),
        name: '工单申诉列表',
        meta: {
          title: '工单申诉列表',
        },
      },
      {
        path: 'appeal/intern-stat',
        component: () => import(/* webpackChunkName: "order-appeal-intern-stat" */ './pages/OrderAppealInternStatTable.vue'),
        name: '工单申诉实习生统计',
        meta: {
          title: '工单申诉实习生统计',
        },
      },
      {
        path: 'appeal/review-order/:id',
        component: () => import(/* webpackChunkName: "order-appeal-review" */ '@views/order-review/pages/OrderReview.vue'),
        name: '工单申诉审核',
        meta: {
          title: '工单申诉审核',
          pageType: 'reviewOrderAppeal',
        },
      },
      {
        path: 'appeal/detail/:id',
        component: () => import(/* webpackChunkName: "order-appeal-detail" */ './pages/OrderAppealDetail.vue'),
        name: '工单申诉详情',
        meta: {
          title: '工单申诉详情',
        },
      },
      {
        path: 'md/table/:id',
        component: () => import(/* webpackChunkName: "MidanOrderTable" */ './pages/MidanOrderTable.vue'),
        name: '米单任务列表',
        meta: {
          title: '米单任务列表',
        },
      },
      {
        path: 'table/platform/:platformtype',
        component: () => import(/* webpackChunkName: "order-table" */ './pages/OrderTable.vue'),
        meta: {
          title: '工单列表',
        },
      },
      {
        path: 'table/platform/:platformtype/status/:status',
        component: () => import(/* webpackChunkName: "order-table" */ './pages/OrderTable.vue'),
        meta: {
          title: '待审核工单列表',
        },
      },
      {
        path: 'detail/:orderid',
        component: () => import(/* webpackChunkName: "order-detail" */ './pages/OrderDetail.vue'),
        name: '工单详情',
        meta: {
          title: '工单详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/order/order.route.js